export { default as logo } from "@/components/assets/Logo_languex.svg";
export { default as logoWhite } from "@/components/assets/logoWhite.svg";
export { default as headerGirl } from "@/components/assets/headerGirl.png";
export { default as humanIcon } from "@/components/assets/humanIcon.svg";
export { default as carbon_delivery } from "@/components/assets/carbon_delivery-parcel.svg";
export { default as flowbite_language } from "@/components/assets/flowbite_language-outline.svg";
export { default as LogoIpsum } from "@/components/assets/LogoIpsum.svg";
export { default as LogoIpsum2 } from "@/components/assets/LogoIpsum2.svg";
export { default as LogoIpsum3 } from "@/components/assets/LogoIpsum3.svg";
export { default as LogoIpsum4 } from "@/components/assets/LogoIpsum4.svg";
export { default as LogoIpsum5 } from "@/components/assets/LogoIpsum5.svg";
export { default as solar_buildings1 } from "@/components/assets/solar_buildings-linear1.svg";
export { default as solar_buildings2 } from "@/components/assets/solar_buildings-linear2.svg";
export { default as solar_buildings3 } from "@/components/assets/solar_buildings-linear3.svg";
export { default as menubg1 } from "@/components/assets/MenuBgImage1.svg";
export { default as menubg2 } from "@/components/assets/MenuBgImage2.svg";
export { default as expert1 } from "@/components/assets/expert1.png";
export { default as expert2 } from "@/components/assets/expert2.png";
export { default as expert3 } from "@/components/assets/expert3.png";
export { default as expert4 } from "@/components/assets/expert4.png";
export { default as expert5 } from "@/components/assets/expert5.png";
export { default as element0 } from "@/components/assets/elment0.svg";
export { default as element1 } from "@/components/assets/elment1.svg";
export { default as element2 } from "@/components/assets/elment2.svg";
export { default as element3 } from "@/components/assets/elment3.svg";
export { default as element4 } from "@/components/assets/elment4.svg";
export { default as line_bg } from "@/components/assets/line-bg.svg";
export { default as shield } from "@/components/assets/shield.svg";
export { default as spicon } from "@/components/assets/spIcon.svg";
export { default as usicon } from "@/components/assets/usIcon.svg";
export { default as gericon } from "@/components/assets/gericon.svg";
export { default as chicon } from "@/components/assets/chIcon.svg";
export { default as arabicon } from "@/components/assets/arbIcon.svg";
export { default as line_bg2 } from "@/components/assets/line-bg2.svg";
export { default as img1 } from "@/components/assets/img1.webp";
export { default as img2 } from "@/components/assets/img2.webp";
export { default as img3 } from "@/components/assets/img3.webp";
export { default as img4 } from "@/components/assets/img4.webp";
export { default as img5 } from "@/components/assets/img5.webp";
export { default as explore } from "@/components/assets/eplorer.svg";
export { default as logob6 } from "@/components/assets/logoBlock6.svg";
export { default as logob6_1 } from "@/components/assets/logoBlock6_2.svg";
export { default as logob6_2 } from "@/components/assets/logoBlock6_3.svg";
export { default as bgLast } from "@/components/assets/LastBlockBG.svg";
export { default as footerLogo1 } from "@/components/assets/footerLogo1.svg";
export { default as footerLogo2 } from "@/components/assets/footerLogo2.svg";
export { default as footerLogo3 } from "@/components/assets/footerLogo3.png";
export { default as footerLogo4 } from "@/components/assets/footerLogo4.svg";
export { default as footerBgImage } from "@/components/assets/fotterBgImage.svg";
export { default as headerMen } from "@/components/assets/headerMen.png";
export { default as headerIconGroup } from "@/components/assets/headerIconGroup.svg";
export { default as docxIcon } from "@/components/assets/docxIcon.svg";
export { default as pdfIcon } from "@/components/assets/pdfIcon.svg";
export { default as iconCheck } from "@/components/assets/iconCheck.svg";
export { default as headerPhotoIcon } from "@/components/assets/headerPhotoIcon.svg";
export { default as headerPhotoIconpng } from "@/components/assets/headerPhotoIcon.png";
export { default as law_icon } from "@/components/assets/law-icon.svg";
export { default as education_icon } from "@/components/assets/education-icon.svg";
export { default as solar_wallet } from "@/components/assets/solar_wallet-money-linear.svg";
export { default as fluent_building } from "@/components/assets/fluent_building-government-20-regular.svg";
export { default as helthcare_icon } from "@/components/assets/helthcare-icon.svg";
export { default as elit_icon } from "@/components/assets/elit_icon.svg";
export { default as built_in_icon } from "@/components/assets/built_in_icon.svg";
export { default as experince_icon } from "@/components/assets/experince_icon.svg";
export { default as dedicated_icon } from "@/components/assets/dedicated_icon.svg";
export { default as approval_icon } from "@/components/assets/approval_icon.svg";
export { default as bg_standart_1 } from "@/components/assets/bg_standart_1.svg";
export { default as bg_standart_2 } from "@/components/assets/bg_standart_2.svg";
export { default as bg_standart_3 } from "@/components/assets/bg_standart_3.svg";
export { default as bg_standart_4 } from "@/components/assets/bg_standart_4.svg";
export { default as image_card_1 } from "@/components/assets/image_card_1.webp";
export { default as image_card_2 } from "@/components/assets/image_card_2.png";
export { default as image_card_3 } from "@/components/assets/image_card_3.png";
export { default as image_card_4 } from "@/components/assets/image_card_4.png";
export { default as doc_big_icon } from "@/components/assets/doc_big_icon.svg";
export { default as logob6_3 } from "@/components/assets/logob6_3.svg";
export { default as headerGirl2 } from "@/components/assets/headerGirl2.png";
export { default as notarizetion_icon } from "@/components/assets/notarizetion_icon.svg";
export { default as mingcute_paper } from "@/components/assets/mingcute_paper-line.svg";
export { default as mingcute_paper_blue } from "@/components/assets/mingcute_paper_blue.png";
export { default as octicon_law } from "@/components/assets/octicon_law-16.svg";
export { default as solid_university } from "@/components/assets/fa-solid_university.svg";
export { default as basil_document } from "@/components/assets/basil_document-solid.svg";
export { default as header_icon_group2 } from "@/components/assets/header_icon_group2.svg";
export { default as Affidavits } from "@/components/assets/Affidavits.png";
export { default as Bank_statements } from "@/components/assets/Bank_statements.png";
export { default as Birth_certificate } from "@/components/assets/Birth_certificate.png";
export { default as Contract } from "@/components/assets/Contract.png";
export { default as Diploma } from "@/components/assets/Diploma.png";
export { default as Financial_Statement } from "@/components/assets/Financial_Statement.png";
export { default as Marriage_Certificate } from "@/components/assets/Marriage_Certificate.png";
export { default as Passport } from "@/components/assets/Passport.png";
export { default as Transcript } from "@/components/assets/Transcript.png";
export { default as ImageMap } from "@/components/assets/ImageMap.png";
export { default as ImageMap2 } from "@/components/assets/ImageMap2.png";
export { default as ImageMap3 } from "@/components/assets/ImageMap3.png";
export { default as headerGirls } from "@/components/assets/headerGirls.png";
export { default as gg_dollar } from "@/components/assets/gg_dollar.svg";
export { default as tdesign_task } from "@/components/assets/tdesign_task.svg";
export { default as majesticons_briefcase } from "@/components/assets/majesticons_briefcase-line.svg";
export { default as mdi_users } from "@/components/assets/mdi_users-add-outline.svg";
export { default as image_Tehnical } from "@/components/assets/imageTehnical.png";
export { default as E_learning } from "@/components/assets/E-learning.png";
export { default as Financial_Report } from "@/components/assets/Financial_Report.png";
export { default as Manual } from "@/components/assets/Manual.png";
export { default as Patent } from "@/components/assets/Patent.png";
export { default as Software } from "@/components/assets/Software.png";
export { default as Video } from "@/components/assets/Video.png";
export { default as Website } from "@/components/assets/Website.png";
export { default as header_icon_group3 } from "@/components/assets/header_icon_group3.svg";
export { default as HeaderMenIcon1 } from "@/components/assets/HeaderMenIcon1.svg";
export { default as HeaderMenIcon2 } from "@/components/assets/HeaderMenIcon2.svg";
export { default as headerGroupIcno4 } from "@/components/assets/headerGroupIcno4.svg";
export { default as header_bg_horizontal_line } from "@/components/assets/header_bg_horizontal.svg";
export { default as header_bg_vertical_line } from "@/components/assets/header_bg_vertical.svg";
export { default as notarized_second_icon } from "@/components/assets/notarized_second_icon.svg";
export { default as License } from "@/components/assets/License.png";
export { default as simplify_card_1 } from "@/components/assets/simplify_card_1.png";
export { default as simplify_card_2 } from "@/components/assets/simplify_card_2.png";
export { default as bg_line_Urgent } from "@/components/assets/bg_line_Urgent.svg";
export { default as red_file } from "@/components/assets/red_file.svg";
export { default as urgent_group_icon } from "@/components/assets/urgent_group_icon.svg";
export { default as second_group_urgent } from "@/components/assets/second_group_urgent.svg";
export { default as mage_file } from "@/components/assets/mage_file-2-fill.svg";
export { default as Email } from "@/components/assets/Email.png";
export { default as Medical_Records } from "@/components/assets/Medical_Records.png";
export { default as Press_release } from "@/components/assets/Press_release.png";
export { default as check_black_icon } from "@/components/assets/check_black_icon.svg";
export { default as quality_second_image_right } from "@/components/assets/quality_second_image_right.svg";
export { default as iconCheck2 } from "@/components/assets/material-symbols_verified-rounded.svg";
export { default as star_x2 } from "@/components/assets/star_x2.svg";
export { default as trust_logo } from "@/components/assets/trust_logo.svg";
export { default as pricing_Footer } from "@/components/assets/pricing_Footer.webp";
export { default as trustpilot } from "@/components/assets/trustpilot-2.svg";

export { default as gridImage1 } from "@/components/assets/gridImage1.png";
export { default as gridImage2 } from "@/components/assets/gridImage2.png";
export { default as gridImage3 } from "@/components/assets/support-form.webp";
export { default as gridImage4 } from "@/components/assets/gridImage4.png";
export { default as supportGrid } from "@/components/assets/support-grid.webp";
export { default as logoHeaderAbout } from "@/components/assets/logoHeaderAbout.svg";
export { default as angelicaMia } from "@/components/assets/angelicaMia.svg";
export { default as iconChecklight } from "@/components/assets/iconChecklight.svg";
export { default as blank_cap } from "@/components/assets/blank_cap.png";
export { default as blank_bank } from "@/components/assets/blank_bank.png";
export { default as blank_web } from "@/components/assets/blank_web.png";
export { default as delivery_box } from "@/components/assets/deliveryBox.png";
export { default as doc_image } from "@/components/assets/docImage.png";
export { default as hero_expert_image } from "@/components/assets/Ellipse.png";
export { default as accept_star_circle } from "@/components/assets/confirm_star_circle.png";
export { default as affidavits } from "@/components/assets/Affidavits.png";
export { default as bank_statements } from "@/components/assets/Bank_statements.png";
export { default as book } from "@/components/assets/book.png";
export { default as brochure } from "@/components/assets/brochure.png";
export { default as contract } from "@/components/assets/Contract.png";
export { default as diploma } from "@/components/assets/Diploma.png";
export { default as eLearning } from "@/components/assets/eLearning.png";
export { default as email_img } from "@/components/assets/emailImg.png";
export { default as employee_handbook } from "@/components/assets/employee_handbook.png";
export { default as financial_report } from "@/components/assets/Financial_Report.png";
export { default as financial_statement } from "@/components/assets/Financial_Statement.png";
export { default as game } from "@/components/assets/game.png";
export { default as license } from "@/components/assets/License.png";
export { default as manual } from "@/components/assets/Manual.png";
export { default as marriage_certificate } from "@/components/assets/Marriage_Certificate.png";
export { default as passport } from "@/components/assets/Passport.png";
export { default as patent } from "@/components/assets/panent.png";
export { default as software } from "@/components/assets/Software.png";
export { default as transcript } from "@/components/assets/Transcript.png";
export { default as video } from "@/components/assets/Video.png";
export { default as website } from "@/components/assets/Website.png";
export { default as standartType } from "@/components/assets/standartType2.svg";
export { default as certifiedType } from "@/components/assets/certifiedType.svg";
export { default as enterpriseType } from "@/components/assets/enterpriseType.svg";
export { default as standart_card_icon } from "@/components/assets/standart_service_card_icon.png";
export { default as official_document_icon } from "@/components/assets/official_document_icon.png";
export { default as enterprise_card_icon } from "@/components/assets/enterprise_card_icon.png";
export { default as arrow_right } from "@/components/assets/arrow-right.png";
export { default as logoHeaderLanguage } from "@/components/assets/logoHeaderLanguage.svg";
export { default as imageHeaderLanguage } from "@/components/assets/imageHeaderLanguage.svg";
export { default as alexAvatar } from "@/components/assets/AlexAvatar.svg";
export { default as ArrowLanguageHeader } from "@/components/assets/ArrowLanguageHeader.svg";
export { default as logoHeaderSpanish } from "@/components/assets/logoHeaderSpanish.svg";
export { default as ix_certificate } from "@/components/assets/ix_certificate-success.svg";
export { default as heroBgSpanish } from "@/components/assets/heroBgSpanish.svg";
export { default as NotarizedSecondBlogImage } from "@/components/assets/Notarized-SecondBlogImage.png";
export { default as industriesHeroImg } from "@/components/assets/industriesHeroImg.webp";
export { default as automotiveHeroImg } from "@/components/assets/automotiveHeroImg.png";
export { default as translatorsImg1 } from "@/components/assets/translatorsImg1.webp";
export { default as translatorsImg2 } from "@/components/assets/translatorsImg2.webp";
export { default as translatorsImg3 } from "@/components/assets/translatorsImg3.webp";
export { default as translatorsImg4 } from "@/components/assets/translatorsImg4.webp";
export { default as translatorsImg5 } from "@/components/assets/translatorsImg5.webp";
export { default as translatorsImg6 } from "@/components/assets/translatorsImg6.webp";
export { default as translatorsImg7 } from "@/components/assets/translatorsImg7.webp";
export { default as translatorsImg8 } from "@/components/assets/translatorsImg8.webp";
export { default as translatorsImg9 } from "@/components/assets/translatorsImg9.webp";
export { default as translatorsImg10 } from "@/components/assets/translatorsImg10.webp";
export { default as translatorsImg11 } from "@/components/assets/translatorsImg11.webp";
export { default as translatorsImg12 } from "@/components/assets/translatorsImg12.webp";
export { default as translatorsImg13 } from "@/components/assets/translatorsImg13.webp";
export { default as translatorsImg14 } from "@/components/assets/translatorsImg14.webp";
export { default as translatorsImg15 } from "@/components/assets/translatorsImg15.webp";
//Logo Start
export { default as porshe } from "@/components/assets/Porsche_Wortmarke_1.svg";
export { default as volvo } from "@/components/assets/volvo-wordmark-black.svg";
export { default as nimbleMotors } from "@/components/assets/nimbleMotors.svg";
export { default as constLogo1 } from "@/components/assets/constLogo1.svg";
export { default as constLogo2 } from "@/components/assets/constLogo2.svg";
export { default as constLogo3 } from "@/components/assets/constLogo3.svg";
export { default as constLogo4 } from "@/components/assets/constLogo4.svg";
export { default as constLogo5 } from "@/components/assets/constLogo5.svg";
export { default as energyLogo1 } from "@/components/assets/energyLogo1.svg";
export { default as energyLogo2 } from "@/components/assets/energyLogo2.svg";
export { default as ecommerceLogo1 } from "@/components/assets/ecommerceLogo1.svg";
export { default as ecommerceLogo2 } from "@/components/assets/ecommerceLogo2.svg";
export { default as ecommerceLogo3 } from "@/components/assets/ecommerceLogo3.svg";
export { default as ecommerceLogo4 } from "@/components/assets/ecommerceLogo4.svg";
export { default as ecommerceLogo5 } from "@/components/assets/ecommerceLogo5.svg";
export { default as ecommerceLogo6 } from "@/components/assets/ecommerceLogo6.svg";
export { default as gamingLogo1 } from "@/components/assets/gamingLogo1.svg";
export { default as gamingLogo2 } from "@/components/assets/gamingLogo2.svg";
export { default as gamingLogo3 } from "@/components/assets/gamingLogo3.svg";
export { default as gamingLogo4 } from "@/components/assets/gamingLogo4.svg";
export { default as insuranceLogo1 } from "@/components/assets/insuranceLogo1.svg";
export { default as insuranceLogo2 } from "@/components/assets/insuranceLogo2.svg";
export { default as insuranceLogo3 } from "@/components/assets/insuranceLogo3.svg";
export { default as insuranceLogo4 } from "@/components/assets/insuranceLogo4.svg";
export { default as insuranceLogo5 } from "@/components/assets/insuranceLogo5.svg";
export { default as manufactureLogo1 } from "@/components/assets/manufactureLogo1.svg";
export { default as manufactureLogo2 } from "@/components/assets/manufactureLogo2.svg";
export { default as mediaLogo1 } from "@/components/assets/mediaLogo1.svg";
export { default as mediaLogo2 } from "@/components/assets/mediaLogo2.svg";
export { default as realEstateLogo1 } from "@/components/assets/realEstateLogo1.svg";
export { default as realEstateLogo2 } from "@/components/assets/realEstateLogo2.svg";
export { default as realEstateLogo3 } from "@/components/assets/realEstateLogo3.svg";
export { default as techLogo1 } from "@/components/assets/techLogo1.svg";
export { default as techLogo2 } from "@/components/assets/techLogo2.svg";
export { default as tourismlogo1 } from "@/components/assets/tourismlogo1.svg";
export { default as tourismlogo2 } from "@/components/assets/tourismlogo2.svg";
export { default as tourismlogo3 } from "@/components/assets/tourismlogo3.svg";
export { default as tourismlogo4 } from "@/components/assets/tourismlogo4.svg";

//Logo End
export { default as icon_park_solid_check_one } from "@/components/assets/icon-park-solid_check-one.png";
export { default as icon_park_solid_check_one_black } from "@/components/assets/icon-park-solid_check-one-black.png";
export { default as shutterImg } from "@/components/assets/shutterImg.png";

export { default as iconAutomotive2 } from "@/components/assets/iconAutomotive2.png";
export { default as iconAutomotive3 } from "@/components/assets/iconAutomotive3.png";
export { default as iconAutomotive4 } from "@/components/assets/iconAutomotive4.png";
export { default as iconAutomotive5 } from "@/components/assets/iconAutomotive5.png";
export { default as iconAutomotive6 } from "@/components/assets/iconAutomotive6.png";

export { default as ConstructionImg } from "@/components/assets/ConstructionImg.png";

export { default as leftImg } from "@/components/assets/leftImg.png";

export { default as teenyicons_floorplan } from "@/components/assets/teenyicons_floorplan.svg";
export { default as iconConst2 } from "@/components/assets/iconConst2.png";
export { default as iconConst3 } from "@/components/assets/iconConst3.png";
export { default as EcommerceIMG } from "@/components/assets/EcommerceIMG.png";
export { default as AccordingIMGEcommerce } from "@/components/assets/AccordingIMGEcommerce.png";

export { default as iconEcommerce1 } from "@/components/assets/iconEcommerce1.png";
export { default as iconEcommerce2 } from "@/components/assets/iconEcommerce2.png";
export { default as EnergyAccordinIMG } from "@/components/assets/EnergyAccordinIMG.png";
export { default as EnergyHeroImg } from "@/components/assets/EnergyHeroImg.png";
export { default as iconEnergy2 } from "@/components/assets/iconEnergy2.png";
export { default as iconEnergy3 } from "@/components/assets/iconEnergy3.png";

export { default as GammingHeroIMG } from "@/components/assets/GammingHeroIMG.png";
export { default as leftGamingIMG } from "@/components/assets/leftGamingIMG.png";
export { default as iconGame1 } from "@/components/assets/iconGame1.png";
export { default as iconGame2 } from "@/components/assets/iconGame2.png";
export { default as iconGame3 } from "@/components/assets/iconGame3.png";
export { default as iconGame4 } from "@/components/assets/iconGame4.png";
export { default as iconGame5 } from "@/components/assets/iconGame5.png";

export { default as insuranceHeroIMG } from "@/components/assets/insuranceHeroIMG.png";
export { default as leftIncuranceIMG } from "@/components/assets/leftIncuranceIMG.png";
export { default as iconIncurance1 } from "@/components/assets/iconIncurance1.png";

export { default as heroIMGManufacturing } from "@/components/assets/heroIMGManufacturing.png";
export { default as leftManufactureIMG } from "@/components/assets/leftManufactureIMG.png";

export { default as mediaHeroIMG } from "@/components/assets/mediaHeroIMG.png";
export { default as leftMediaIMG } from "@/components/assets/leftMediaIMG.png";
export { default as iconMedia1 } from "@/components/assets/iconMedia1.png";
export { default as iconMedia2 } from "@/components/assets/iconMedia2.png";

export { default as realEstateHeroIMG } from "@/components/assets/realEstateHeroIMG.png";
export { default as leftrealEstateIMG } from "@/components/assets/leftrealEstateIMG.png";
export { default as realEstateIcon1 } from "@/components/assets/realEstateIcon1.png";
export { default as realEstateIcon2 } from "@/components/assets/realEstateIcon2.png";

export { default as technologyHeroIMG } from "@/components/assets/technologyHeroIMG.png";
export { default as leftTechIMG } from "@/components/assets/leftTechIMG.png";
export { default as iconTech1 } from "@/components/assets/iconTech1.png";
export { default as iconTech2 } from "@/components/assets/iconTech1.png";

export { default as tourismHeroIMG } from "@/components/assets/tourismHeroIMG.png";
export { default as leftTourismIMG } from "@/components/assets/leftTourismIMG.png";

export { default as useCaseHeroIMG } from "@/components/assets/useCaseHeroIMG.webp";
export { default as imgUseCase1 } from "@/components/assets/imgUseCase1.webp";
export { default as imgUseCase2 } from "@/components/assets/imgUseCase2.webp";
export { default as imgUseCase3 } from "@/components/assets/imgUseCase3.webp";
export { default as imgUseCase4 } from "@/components/assets/imgUseCase4.webp";
export { default as imgUseCase5 } from "@/components/assets/imgUseCase5.webp";
export { default as imgUseCase6 } from "@/components/assets/imgUseCase6.webp";
export { default as imgUseCase7 } from "@/components/assets/imgUseCase7.webp";
export { default as imgUseCase8 } from "@/components/assets/imgUseCase8.webp";
export { default as imgUseCase9 } from "@/components/assets/imgUseCase9.webp";
export { default as imgUseCase10 } from "@/components/assets/imgUseCase10.png";
export { default as imgUseCase11 } from "@/components/assets/imgUseCase11.png";
export { default as imgUseCase12 } from "@/components/assets/imgUseCase12.png";

export { default as marketingHeroIMG } from "@/components/assets/marketingHeroIMG.png";
export { default as leftMarketingIMG } from "@/components/assets/leftMarketingIMG.png";
export { default as iconMarketing1 } from "@/components/assets/iconMarketing1.png";
export { default as iconMarketing2 } from "@/components/assets/iconMarketing2.png";
export { default as iconMarketing3 } from "@/components/assets/iconMarketing3.png";
export { default as iconMarketing4 } from "@/components/assets/iconMarketing4.png";
export { default as iconMarketing5 } from "@/components/assets/iconMarketing5.png";

export { default as academicHeroIMG } from "@/components/assets/academicHeroIMG.png";
export { default as academicLogo1 } from "@/components/assets/academicLogo1.svg";
export { default as academicLogo2 } from "@/components/assets/academicLogo2.svg";
export { default as academicLogo3 } from "@/components/assets/academicLogo3.svg";
export { default as academicLogo4 } from "@/components/assets/academicLogo4.svg";
export { default as leftAcademicIMG } from "@/components/assets/leftAcademicIMG.png";
export { default as iconAcademic1 } from "@/components/assets/iconAcademic1.png";
export { default as iconAcademic2 } from "@/components/assets/iconAcademic2.png";
export { default as iconAcademic3 } from "@/components/assets/iconAcademic3.png";
export { default as iconAcademic4 } from "@/components/assets/iconAcademic4.png";
export { default as iconAcademic5 } from "@/components/assets/iconAcademic5.png";

export { default as advantage1 } from "@/components/assets/advantage1.webp";
export { default as advantage2 } from "@/components/assets/advantage2.webp";
export { default as advantage3 } from "@/components/assets/advantage3.webp";
export { default as footerBgImageMobile } from "@/components/assets/footerBgImageMobile.webp";
export { default as allDocumentsHero } from "@/components/assets/all-documents-hero.webp";
export { default as languagesHero } from "@/components/assets/languages-hero.webp";
export { default as servicesStandardHero } from "@/components/assets/services-standard-hero.webp";
export { default as servicesCertifiedHero } from "@/components/assets/services-certified-hero.webp";
export { default as servicesEnterpriseHero } from "@/components/assets/services-enterprise-hero.webp";
export { default as servicesNotarizedHero } from "@/components/assets/services-notarized-hero.webp";
export { default as servicesNotarizedEnsureCompliance } from "@/components/assets/services-notarized-ensure-compliance.webp";
export { default as servicesUrgentEnsureCompliance } from "@/components/assets/services-urgent-ensure-compliance.webp";
export { default as servicesUrgentHero } from "@/components/assets/services-urgent-hero.webp";
export { default as servicesQualityPromises } from "@/components/assets/services-quality-promises.webp";
export { default as aboutUsHero } from "@/components/assets/about-us-hero.webp";
export { default as aboutUsOurRoots } from "@/components/assets/about-us-our-roots.webp";
export { default as aboutUsExcellence } from "@/components/assets/about-us-excellence.webp";
export { default as aboutUsHumanConnection } from "@/components/assets/about-us-human-connection.webp";
export { default as aboutUsTeam } from "@/components/assets/about-us-team.webp";
export { default as womanIndustry } from "@/components/assets/woman-industry.webp";
export { default as heroHome } from "@/components/assets/hero-home.webp";
export { default as heroHomeMobile } from "@/components/assets/hero-home-mobile.webp";
export { default as securityTrust } from "@/components/assets/security-trust.webp";
export { default as supportForm } from "@/components/assets/support-form.webp";
export { default as avatarWomen } from "@/components/assets/avatar-women.webp";
export { default as security_support1 } from "@/components/assets/security-support1.webp";
export { default as security_support2 } from "@/components/assets/security-support2.webp";
export { default as security_support3 } from "@/components/assets/security-support3.webp";









